<script setup lang="ts">
import { computed, onMounted, onUnmounted, watch } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { Toaster } from '@/components/ui/sonner'
import { useUserStore } from '@/manage/stores/user'
import GlobalDialogHost from '@/manage/shared/dialog/GlobalDialogHost.vue'
import { logger } from '@/utils/logger'
// import { checkVersion } from '@/shared/composables/useVersionCheck'

const userStore = useUserStore()
const route = useRoute()
const isManageRoute = computed(() => route.path.startsWith('/manage'))

const syncManageRouteClass = (enabled: boolean) => {
  document.documentElement.classList.toggle('easyhire-manage-route', enabled)
  document.body.classList.toggle('easyhire-manage-route', enabled)
}

const handleVisibilityChange = () => {
  if (!isManageRoute.value) return
  void userStore.refreshSessionOnVisibility().catch((error: unknown) => {
    logger.warn('[EasyHire] Visibility-driven session refresh failed', error)
  })
}

onMounted(() => {
  document.addEventListener('visibilitychange', handleVisibilityChange)
  // 启动时检测一次新版本(强制跳过 throttle)
  // void checkVersion(true)
})

watch(
  () => [isManageRoute.value, userStore.isAuthenticated] as const,
  async ([manageRoute, isAuthenticated]) => {
    if (manageRoute && isAuthenticated) {
      await userStore.fetchAsset()
    }
  },
  { immediate: true },
)

onUnmounted(() => {
  document.removeEventListener('visibilitychange', handleVisibilityChange)
  syncManageRouteClass(false)
})

watch(isManageRoute, syncManageRouteClass, { immediate: true })
</script>

<template>
  <RouterView />
  <GlobalDialogHost />
  <Toaster position="top-right" rich-colors close-button />
</template>

<style scoped></style>
